import { connect } from 'react-redux'

import SpeechHitsPanel, { UnstyledSpeechHitsPanel } from './SpeechHitsPanel'
import { withAuthenticatedUser } from '../../../Permissions'
import { SOURCE_TYPE } from '../SpeechPanel/speech.constants'

const transcriptionHitToSpeechHit = channel => ({ audio: { start, end }, category, confidence, phrase }) => ({
  start,
  stop: end,
  category,
  confidence,
  phrase,
  channel,
  source: SOURCE_TYPE.TRANSCIRPTION,
})
const getTranscriptionHits = transcription =>
  !transcription || !transcription.texts
    ? []
    : transcription.texts.reduce(
      (allHits, { hits, channel }) => [...allHits, ...hits.map(transcriptionHitToSpeechHit(channel))],
      [],
    )

const mapStateToProps = ({
  media: {
    main: { contact, storageFile },
    speech,
    transcription,
  },
}) => {
  //TODO put in reducer
  const transcriptionHits = getTranscriptionHits(transcription)
  const speechHits = speech.data && speech.data.hits ? speech.data.hits : []

  return {
    loading: contact.loading || storageFile.loading || speech.loading,
    error: contact.error || storageFile.error || speech.error || transcription.error,
    speechHits: [...speechHits, ...transcriptionHits],
  }
}

export { UnstyledSpeechHitsPanel }

export default withAuthenticatedUser(connect(mapStateToProps)(SpeechHitsPanel))
